import { AdvanceAmount } from "../../types";

// An advance's amounts in a table cell - one currency per line, so a
// multi-currency advance stays readable in a narrow Amount column (used by
// MyRequests.tsx's and ApproverQueue.tsx's advance tables).
export function AdvanceAmountsCell({ amounts }: { amounts: AdvanceAmount[] }) {
  if (amounts.length === 0) {
    return <span className="text-muted-foreground">-</span>;
  }
  return (
    <span className="block font-semibold tabular-nums">
      {amounts.map((a) => (
        <span key={a.currency} className="block whitespace-nowrap">
          {a.currency} {a.amount.toLocaleString()}
        </span>
      ))}
    </span>
  );
}
